module.exports = __webpack_public_path__ + "img/DW365-057.06665627.jpg";